module.exports = __webpack_public_path__ + "e99b1b25bcd65335dde4a2308daaabf2.png";